import React, { useEffect } from "react";
import Card from "components/card";
import CardItem from "components/card/CardItem";
import { Form, Input, DatePicker, Select, InputNumber, Checkbox } from 'antd';
import dayjs from 'dayjs';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getFinalPayDetails, doFinalPayCreate, doFinalPayUpdate 
} from "../../../../redux/finalpay/finalPayState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";
import { ReactComponent as CompanyLogo } from 'assets/svg/intsamis_logo.svg';
import { NumberFormatter } from "../../../../utils/index";

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

const FinalPayForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			
			const { ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	        };
			
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {  
			const { effective_date, ...forSubmitValues } = values;			  
			//forSubmitValues.fpa_lc_date_from = effective_date[0].format('YYYY-MM-DD');
			//forSubmitValues.fpa_lc_date_to = effective_date[1].format('YYYY-MM-DD');	
			recordData.fpa_id > 0 ? doUpdate(forSubmitValues): doCreate(forSubmitValues); 
			
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};

	const lastPayComputation = [
		{title: "Basic Pay", taxable:"fpa_basic_pay", nontaxable: "_blank"},
		{title: "Tardiness/Undertime/Absence", taxable:"fpa_alu", nontaxable: "_blank"},
		{title: "De Minimis Allowance", taxable:"_blank", nontaxable: "fpa_de_minimis"},
		{title: "Service Allowance", taxable:"fpa_service_allowance_t", nontaxable: "fpa_service_allowance_nt"},
		{title: "Special Allowance", taxable:"fpa_special_allowance_t", nontaxable: "fpa_special_allowance_nt"},
		{title: "Night Differential", taxable:"fpa_night_differential", nontaxable: "_blank"},
		{title: "Overtime Pay", taxable:"fpa_overtime", nontaxable: "_blank"},
		{title: "Holiday Pay", taxable:"fpa_holiday_pay", nontaxable: "_blank"},
		{title: "Incentive / Bonus", taxable:"_blank", nontaxable: "fpa_incentives_bonus"},
		{title: "Other Earnings", taxable:"fpa_other_earnings_t", nontaxable: "fpa_other_earnings_nt"},
	];

	const taxComputation = [
		{title: "Gross Earnings", taxable:"fpa_gross_earnings_t", nontaxable: "fpa_gross_earnings_nt"},
		{title: "Statutory Contributions", taxable:"fpa_statutory_contri_t", nontaxable: "fpa_statutory_contri_nt"},
		{title: "Taxable Earnings", taxable:"fpa_taxable_earnings", nontaxable: "_blank"},
		{title: "Allowances", taxable:"fpa_allowances_t", nontaxable: "fpa_allowances_nt"},
		{title: "Incentives / Bonus", taxable:"fpa_incentives_t", nontaxable: "fpa_incentives_nt"},
		{title: "13th Month Pay", taxable:"fpa_13th_amount_t", nontaxable: "fpa_13th_amount_nt"},
		{title: "Leave Conversion", taxable:"fpa_lc_amount_t", nontaxable: "fpa_lc_amount_nt"},
		{title: "Other Earnings", taxable:"fpa_other_earnings_t", nontaxable: "fpa_other_earnings_nt"},
	];
  
  	return (
		<>
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="fpa_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
				<div className="grid grid-cols-4">
					<FormItem className="font-medium mb-2"
						name="fpa_employee_id"
						label="Employee"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Select id="fpa_employee_id"
							showSearch
							allowClear={true}
							style={{
								width: 250,
								}}
							options={recordData?.employeeList}
							filterOption={(input, option) =>
								(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
							}
						/>
						: <label className="ps-3 dark:text-white">{recordData?.fpa_employee_name}</label>
						}	                
					</FormItem>
					<FormItem className="font-medium mb-2"
						name="fpa_status_id"
						label="Status"
					>
						{mode === 'edit' ?
						<Select id="fpa_status_id"
							style={{
								width: 150,
								}}
								options={recordData?.statusList}
						/>		            		
						: <label className="ps-3 dark:text-white">{recordData?.fpa_status_name}</label>
						}
					</FormItem>
				</div>
				{mode === 'edit' &&
        		<div className="grid grid-cols-4">
        			 <FormItem className="font-medium mb-2"
		            	name="leave_convertion"
		                label="Leave Conversion"
		            >
		            	<RangePicker className="font-normal"
		            		format={dateFormat}
		            		style={{
						        width: 250,
						      }}
		            	/>
	            	</FormItem> 
	            	<FormItem className="font-medium mb-2"
		            	name="fpa_leave_accrued"
		                label="Accrued Hours"
		            >
		            	<InputNumber precision={2}
		                    id="fpa_leave_accrued"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
		            	/>
	            	</FormItem>	
					<FormItem className="font-medium mb-2"
		            	name="fpa_leave_used"
		                label="Used Hours"
		            >
		            	<InputNumber precision={2}
		                    id="fpa_leave_used"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
		            	/>
	            	</FormItem>	
					<FormItem className="font-medium mb-2"
		            	name="fpa_lc_amount"
		                label="Amount"
		            >
		            	<InputNumber precision={2}
		                    id="fpa_lc_amount"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
		            	/>
	            	</FormItem>	
	 			</div>
				}	
				<div className="grid grid-cols-4">
					<FormItem className="font-medium  mb-2 col-span-2"
						name="fpa_notes"
						label="Notes"
						initialValue={recordData?.fpa_notes}
					>
						{mode === 'edit' ?
						<TextArea className="py-2"
							rows={2}
							maxLength={500}
						/>
						: <label className="ps-3 dark:text-white">{recordData?.fpa_notes}</label>
						}
					</FormItem>
				</div> 	
	 			<CrudButtons baseRoute="/console/final-pays" mode={mode} recordId={recordId} />			 			
	 		</Form>	 	
	 	</Card>

		{ mode === 'view' && 
			<CardItem extra={"w-full h-full p-4"}>
				<div className="flex justify-start items-center mb-3 border border-brand-600 rounded">
			      	<div className="p-5 ml-5">
			      		<CompanyLogo className="w-[80px] h-auto"/>
			      	</div>
			      	<div className="flex w-full justify-center pr-[100px]">
		        		<h2 className="font-bold text-[24px] uppercase">Final Pay Computation</h2>
		        	</div>
		    	</div>
				<div className="grid grid-cols-2 mt-4 p-4 border border-brand-600 rounded">
					<div className="grid grid-cols-3 font-medium mb-2 item-start">
						<div className="font-bold text-[14px] dark:text-white">Employee ID</div>
						<div className="col-span-2 font-medium text-[14px] ps-3 dark:text-white">{recordData?.employee?.emp_code}</div>

						<div className="font-bold text-[14px] dark:text-white">Employee Name</div>
						<div className="col-span-2 font-medium text-[14px] ps-3 dark:text-white">{recordData?.employee?.emp_name}</div>

						<div className="font-bold text-[14px] dark:text-white">Designation</div>
						<div className="col-span-2 font-medium text-[14px] ps-3 dark:text-white">{recordData?.employee?.emp_title}</div>
					</div>

					<div className="grid grid-cols-3 font-medium mb-2">
						<div className="font-bold text-[14px] dark:text-white">Hire Date</div>
						<div className="col-span-2 font-medium text-[14px] ps-3 dark:text-white">{recordData?.employee?.emp_hire_date}</div>

						<div className="font-bold text-[14px] dark:text-white">Separation Date</div>
						<div className="col-span-2 font-medium text-[14px] ps-3 dark:text-white">{recordData?.employee?.emp_separation_date}</div>

						<div className="font-bold text-[14px] dark:text-white">Department</div>
						<div className="col-span-2 font-medium text-[14px] ps-3 dark:text-white">{recordData?.employee?.emp_department_name}</div>
					</div>
				</div>

				<div className="grid grid-cols-1 mt-4 md:grid-cols-2 gap-0 md:gap-2">
					<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
						<div className="flex flex-row gap-4 justify-between">
							<div className="font-black">Monthly Base Pay</div>
							<div className="text-right pe-2">{NumberFormatter(recordData?.fpa_salary)}</div>
						</div>
					</div> 
					<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
						<div className="flex flex-row gap-4 justify-between">
							<div className="font-black">Daily Rate</div>
							<div className="text-right pe-2">{NumberFormatter(recordData?.fpa_daily_rate)}</div>
						</div>
					</div> 
				</div>

				<div className="grid grid-cols-1 mt-4 md:grid-cols-4 gap-0 md:gap-2">
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black uppercase">Last Pay Computation</div>
					</div> 
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">Taxable</div>
					</div>
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">Non-Taxable</div>
					</div>
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">Total</div>
					</div>
				</div>

				{lastPayComputation.map((item) => (
				<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2" key={item.title}>
					<div className="flex flex-col gap-2 px-2">
						<div className="">{item.title}</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter(recordData?.[item.taxable], 2, '-')}</div>
					</div>
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter(recordData?.[item.nontaxable], 2,'-')}</div>
					</div>
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter((recordData?.[item.nontaxable] ?? 0) + (recordData?.[item.taxable] ?? 0), 2,'-')}</div>
					</div>
				</div>
				))}
				<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-200">
					<div className="flex flex-col col-span-3 gap-2 px-2">
						<div className="font-black text-right uppercase">Total Amount</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_last_pay_amount)}</div>
					</div>
				</div>

				<div className="grid grid-cols-1 mt-4 md:grid-cols-4 gap-0 md:gap-2">
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black uppercase">13th Month Pay Computation</div>
					</div> 
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">Base Pay</div>
					</div>
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">Tardy / Undertime / Absence</div>
					</div>
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">13th Month Pay Base</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2">
					<div className="flex flex-col gap-2 px-2">
						<div className="">{recordData?.fpa_13th_date_range}</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter(recordData?.fpa_13th_base_pay, 2, '-')}</div>
					</div>
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter(recordData?.fpa_13th_alu, 2,'-')}</div>
					</div>
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter(recordData?.fpa_13th_base_pay - recordData?.fpa_13th_alu, 2,'-')}</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-200">
					<div className="flex flex-col col-span-3 gap-2 px-2">
						<div className="font-black text-right uppercase">13th Month Amount</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_13th_amount, 2,'-')}</div>
					</div>
				</div>

				{recordData?.fpa_lc_amount >= 0 && 
				<>
					<div className="grid grid-cols-1 mt-4 md:grid-cols-4 gap-0 md:gap-2">
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black uppercase">Leave Conversion</div>
						</div> 
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black text-right uppercase">Accrued (Hours)</div>
						</div>
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black text-right uppercase">Used (Hours)</div>
						</div>
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black text-right uppercase">Conversion (Hours)</div>
						</div>
					</div>
					<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2">
						<div className="flex flex-col gap-2 px-2">
							<div className="">{`${recordData?.fpa_lc_date_from ?? ''} - ${recordData?.fpa_lc_date_to ?? ''}`}</div>
						</div> 
						<div className="flex flex-col gap-2 px-2">
							<div className="text-right">{NumberFormatter(recordData?.fpa_leave_accrued, 2, '-')}</div>
						</div>
						<div className="flex flex-col gap-2 px-2">
							<div className="text-right">{NumberFormatter(recordData?.fpa_leave_used, 2,'-')}</div>
						</div>
						<div className="flex flex-col gap-2 px-2">
							<div className="text-right">{NumberFormatter(recordData?.fpa_leave_accrued - recordData?.fpa_leave_used, 2,'-')}</div>
						</div>
					</div>
					<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-200">
						<div className="flex flex-col col-span-3 gap-2 px-2">
							<div className="font-black text-right uppercase">Leave Conversion Amount</div>
						</div> 
						<div className="flex flex-col gap-2 px-2">
							<div className="font-black text-right">{NumberFormatter(recordData?.fpa_lc_amount, 2,'-')}</div>
						</div>
					</div>
				</>
				}

				<div className="grid grid-cols-1 mt-4 md:grid-cols-4 gap-0 md:gap-2">
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black uppercase">Tax Computation</div>
					</div> 
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">Taxable</div>
					</div>
					<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
						<div className="font-black text-right uppercase">Non-Taxable</div>
					</div>
				</div>
				
				{taxComputation.map((item) => (
				<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2" key={item.title}>
					<div className="flex flex-col gap-2 px-2">
						<div className="">{item.title}</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter(recordData?.[item.taxable], 2, '-')}</div>
					</div>
					<div className="flex flex-col gap-2 px-2">
						<div className="text-right">{NumberFormatter(recordData?.[item.nontaxable], 2,'-')}</div>
					</div>
				</div>
				))}

				<div className="grid grid-cols-1 mt-4 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-50">
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black uppercase">Net Taxable Income </div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_taxable_earnings, 2,'-')}</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded">
					<div className="flex flex-col gap-2 px-2">
						<div className="font-medium">Excess Income to be Taxed</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-medium text-right">-</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded">
					<div className="flex flex-col gap-2 px-2">
						<div className="font-medium">Tax Rate</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-medium text-right">0%</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded">
					<div className="flex flex-col gap-2 px-2">
						<div className="font-medium">Base Tax</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-medium text-right">-</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-50">
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black">Total Tax Due</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_total_tax_due, 2,'-')}</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-50">
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black">Total Tax Withheld</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_total_tax_withheld, 2,'-')}</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-2 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-50">
					<div className="flex flex-col gap-2 px-2 col-span-3">
						<div className="font-black">Tax Due (Refund)</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_tax_due_or_refund, 2,'-')}</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-2 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-50">
					<div className="flex flex-col gap-2 px-2 col-span-3">
						<div className="font-black uppercase">Gross Final Pay</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_gross_final_pay, 2,'-')}</div>
					</div>
				</div>
				<div className="grid grid-cols-1 mt-2 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-50">
					<div className="flex flex-col gap-2 px-2 col-span-3">
						<div className="font-black uppercase">Severance Pay</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_severance_pay, 2,'-')}</div>
					</div>
				</div>

					<div className="grid grid-cols-1 mt-4 md:grid-cols-4 gap-0 md:gap-2">
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black uppercase">Other Deductions</div>
						</div> 
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black text-right uppercase">Amount</div>
						</div>
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black text-right uppercase">Payment</div>
						</div>
						<div className="flex flex-col gap-1 p-2 border border-brand-600 rounded bg-gray-100">
							<div className="font-black text-right uppercase">Balance</div>
						</div>
					</div>
				{recordData?.other_deductions.map((item) => (
					<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2" key={item.sdd_id}>
						<div className="flex flex-col gap-2 px-2">
							<div className="">{item.sdd_other_specific ?? item.sdd_paycode_name}</div>
						</div> 
						<div className="flex flex-col gap-2 px-2">
							<div className="text-right">{NumberFormatter(item.sdd_total_amount, 2, '-')}</div>
						</div>
						<div className="flex flex-col gap-2 px-2">
							<div className="text-right">{NumberFormatter(item.sdd_total_payment, 2,'-')}</div>
						</div>
						<div className="flex flex-col gap-2 px-2">
							<div className="text-right">{NumberFormatter(item.sdd_total_amount - item.sdd_total_payment)}</div>
						</div>
					</div>
				))}
					<div className="grid grid-cols-1 mt-1 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-gray-200">
						<div className="flex flex-col gap-2 px-2 col-span-3">
							<div className="font-black uppercase text-right">Other Deductions Amount</div>
						</div> 
						<div className="flex flex-col gap-2 px-2">
							<div className="font-black text-right">{NumberFormatter(recordData?.fpa_total_other_deductions, 2,'-')}</div>
						</div>
					</div>

				<div className="grid grid-cols-1 mt-4 p-2 md:grid-cols-4 gap-0 md:gap-2 border border-brand-600 rounded bg-brandLinear">
					<div className="flex flex-col gap-2 px-2 col-span-3">
						<div className="font-black uppercase">Final Pay Amount</div>
					</div> 
					<div className="flex flex-col gap-2 px-2">
						<div className="font-black text-right">{NumberFormatter(recordData?.fpa_amount, 2,'-')}</div>
					</div>
				</div>
			</CardItem>
		}

		</>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.finalPay.finalPayDetails?.data,
  	requesting: state.finalPay.finalPayDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFinalPayDetails(id)),
  	doCreate: (data) => dispatch(doFinalPayCreate(data)),
  	doUpdate: (data) => dispatch(doFinalPayUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPayForm);
